// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__fm5nH","tag_key":"tag_tag_key__6V8nL","tag_value":"tag_tag_value__UJl4M"};